// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1735":"47a103d5db35c82b","1869":"f272f05f0102edd7"}[chunkId] + ".css";
};